import React from 'react';
import DOMPurify from 'dompurify';
import memoizeOne from 'memoize-one';
import { renderToStaticMarkup } from 'react-dom/server';
import CalendarIconComponent from '@atlaskit/icon/glyph/calendar';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import { gridSize } from '@atlassian/jira-common-styles/src/main.tsx';
import type { IntlShape } from '@atlassian/jira-intl/src/index.tsx';
import { SEARCH_BY } from '../../../common/summary/constants.tsx';
import { getFormattedLabel } from '../../../common/summary/utils/index.tsx';
import type { Point } from '../../../common/types.tsx';
import messages from './messages.tsx';

const getCalendarIcon = memoizeOne(() =>
	renderToStaticMarkup(
		<CalendarIconComponent
			label=""
			primaryColor={token('color.icon.inverse', colors.N50)}
			size="medium"
		/>,
	),
);

const getYAxisValue = (intl: IntlShape, { data }: Point): string =>
	getFormattedLabel(data.valueType, data.value, intl.formatMessage);

export const getSeriesLabelValueString = (intl: IntlShape, points: Point[]): string =>
	points
		.map(
			(point) =>
				`${point.marker} ${getYAxisValue(intl, point)} - ${DOMPurify.sanitize(point.seriesName)}`,
		)
		.join('<br />');

/**
 * formatTooltip
 * this call back function accepts points returned from chart events
 * returns stringified html that render's as tooltip
 */
export const formatTooltip = (
	intl: IntlShape,
	points: Point[],
	searchBy: string,
) => `<div style="padding: ${gridSize}px;
                border-radius: ${gridSize * 0.375}px;">
                <span style="display: flex;align-items: center;">
                    ${getCalendarIcon()}
                    <span style="font-size:${gridSize * 2}px; align-self: flex-end;">
                        ${
													searchBy === SEARCH_BY.weekly
														? intl.formatMessage(messages.weekStartingLabel, {
																formattedDate: points[0].data.formattedDate,
															})
														: points[0].data.formattedDate
												}
                    </span>
                </span>
                <br />
                ${getSeriesLabelValueString(intl, points)}
            </div>
            `;
